import { applyMiddleware, compose, createStore, Store, StoreEnhancer } from 'redux';
import { createLogger } from 'redux-logger';
import { createEpicMiddleware } from 'redux-observable';
import { persistReducer, persistStore } from 'redux-persist';
import { createBlacklistFilter } from 'redux-persist-transform-filter';
import { IAction } from 'src/js/actions/IshAction';
import { ConfigConstants } from './config/ConfigConstants';
import { EnvironmentConstants } from './config/EnvironmentConstants';
import { localForage } from './constants/LocalForage';
import { EpicRoot } from './EpicRoot';
import { combinedReducers } from './reducers/reducers';
import { IshState } from './services/IshState';

const epicMiddleware = createEpicMiddleware();

const getMiddleware = (): StoreEnhancer<IshState> => {
  const logger = createLogger({
    collapsed: true,
  });


  
  /**
   * Split middlewares which we using in development and in production.
   */
  if (process.env.NODE_ENV === EnvironmentConstants.development) {
    const composeEnhancers = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      // @ts-ignore
      ? global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 50 })
      : compose;

    return composeEnhancers(applyMiddleware(epicMiddleware, logger));
  } else {
    return applyMiddleware(epicMiddleware) as any;
  }
};

// Clear only Payment form values on store persist
const formBlacklistFilter = createBlacklistFilter(
  'form',
  ['PaymentForm'],
);

const rootPersistConfig = {
  key: 'checkoutRoot',
  storage: localForage,
  blacklist: ['phase', 'page', 'contactAddProcess', 'config', 'preferences'],
  transforms: [formBlacklistFilter],
};

const persistedReducer = persistReducer(rootPersistConfig, combinedReducers);

export const CreateStore = (): Store<IshState> => {
  const store: Store<IshState> = createStore(
    persistedReducer,
    <StoreEnhancer<IshState>>getMiddleware(),
  ) as Store<IshState>;

  epicMiddleware.run(EpicRoot);

  return store;
};


export const RestoreState = (store: Store<IshState,IAction<any>>, start): void => {
  const persistor = persistStore(store as any);

  const persistStoreWrapper = () => {
    localForage.setItem('appVersion', ConfigConstants.APP_VERSION).catch(e => {
      console.error(e);
    });
  };


  localForage.getItem('appVersion').then(val => {
    if (val && val != ConfigConstants.APP_VERSION) {
      localForage.clear().then(() => {
        persistStoreWrapper();
      }).catch(e => {
        console.error(e);
      });
    } else {
      persistStoreWrapper();
    }
  }).catch(e => {
    console.error(e);
  });

  start(store, persistor);
};

